import axios from 'axios'
import { Cookies } from 'react-cookie'
const endPoint = `/wish/`

const cookie = new Cookies()

const token = await cookie.get('user')

export const addWish = async (product_id) => {
    await axios.post(`${endPoint}`, { product_id: product_id }, { headers: { authorization: token } })
}
export const get_wish = async () => {
    return (await (await axios.get(`${endPoint}`, { headers: { 'Authorization': token } })).data.response)
}

export const delete_wish = async (id) => {
    await axios.delete(`${endPoint}${id}`, {}, { headers: { authorization: token } })
}